(function () {
	'use strict';
	$(document).ready(function () {

		function getJob(jobId) {
			$.ajax({
				url: "/wp/wp-admin/admin-ajax.php",
				method: "post",
				timeout: 10000,
				data: {
					action: "get_job",
					job_id: jobId,
				},
				success: function (data) {
					$('#job-modal .job-body').append(data);
					$('#job-modal .modal-close').addClass('open');
					$('#job-modal .modal-job').mCustomScrollbar({
						mouseWheel: {
							axis: 'y',
							enable: true
						}
					});
				},
				error: function () {
					$('#job-modal #loading-error').show();
				},
				beforeSend: function () {
					$('#job-modal #loading-error').hide();
					$('#job-modal #loader').show();
				},
				complete: function () {
					$('#job-modal #loader').hide();
				},
			});
		}

		$('.career .js-job-excerpt').on('click', function() {
			const jobId = $(this).data('jobid');
			getJob(jobId);
		});

		$('#job-modal').on('hidden.bs.modal', function (e) {
			$('#job-modal .job-body').empty();
			$('#job-modal .modal-close').removeClass('open');
		});

	});
}(jQuery));